import React from 'react';

export const Grid = ({ children, ...divProps }) => {
  return (
    <div className={'fds-layout-grid'} {...divProps}>
      {children}
    </div>
  );
};

export const GridRow = ({ children, ...divProps }) => {
  return (
    <div className={'fds-layout-grid__inner fmc-mb-4'} {...divProps}>
      {children}
    </div>
  );
};

export const GridColumn = ({
  span = 12,
  children,
  className = '',
  ...divProps
}) => {
  return (
    <div
      className={`fds-layout-grid__cell--span-${span} ${className}`}
      {...divProps}
    >
      {children}
    </div>
  );
};
